import { render, staticRenderFns } from "./LoanInfo.vue?vue&type=template&id=2f51aa12&scoped=true&"
import script from "./LoanInfo.vue?vue&type=script&lang=js&"
export * from "./LoanInfo.vue?vue&type=script&lang=js&"
import style0 from "./LoanInfo.vue?vue&type=style&index=0&id=2f51aa12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../PatientEnrollment/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f51aa12",
  null
  
)

export default component.exports